import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "../Sidebar";
import { Header } from "../Header";
import Banner from "../components/Banner";
import SliderContainer from "../components/SliderContainer";
import { Footer } from "../Footer";

import { base_url } from "../../context/Authcontext";
import { useNavigate } from "react-router-dom";


const RummyHome = () => {
  const [isSidebar, setSidebar] = useState(false);
  const navigate= useNavigate();
  const jdb_games=[
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Soar.png",
      name: "Dragon Soar",
      GAMEID:
        "9341a18d096ad901ef77338998f29098",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Pop-Pop-Candy.png",
      name: "Pop Pop Candy",
      GAMEID:
        "fde142e65f14da39f784e9e5325e0a77",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Open-Sesame-Mega.png",
      name: "Open Sesame Mega",
      GAMEID:
        "cb5e57be0354264c6c7ea0cdf4eb18b3",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fruity-Bonanza.png",
      name: "Fruity Bonanza",
      GAMEID:
        "f5d6b418b755f3aefe3b9828f3112c9c",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Caishen-Coming.png",
      name: "Caishen Coming",
      GAMEID:
        "45ecec5dd5077785e7a09988b95bbd24",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Coocoo-Farm.png",
      name: "Coocoo Farm",
      GAMEID:
        "d1f17fd51e474b0e72892332ea551ba1",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Elemental-Link-Water.png",
      name: "Elemental Link Water",
      GAMEID:
        "b84274cdfa5731945a34bfd0db1ddeea",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Elemental-Link-Fire.png",
      name: "Elemental Link Fire",
      GAMEID:
        "46016a772b92c7f47dfdc5873f184ef1",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Birdsparty-Deluxe.png",
      name: "Birdsparty Deluxe",
      GAMEID:
        "786d1cd7f4fa9905c825378292f1204c",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Moneybags-Man-2.png",
      name: "Moneybags Man 2",
      GAMEID:
        "33c862e7db9e0e59ab3f8fe770f797da",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Trump-Card.png",
      name: "Trump Card",
      GAMEID:
        "96c010fc4a95792401e903213d7add44",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fortune-Neko.png",
      name: "Fortune Neko",
      GAMEID:
        "49b706ccfe7c53727ee6760cd9a8721a",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Book-Of-Mystery.png",
      name: "Book Of Mystery",
      GAMEID:
        "13072a6eb2111c1b5202fe6155227e94",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Prosperitytiger.png",
      name: "Prosperitytiger",
      GAMEID:
        "1d704bbb187a113229f3fdaa3b5406fe",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Glamorous-Girl.png",
      name: "Glamorous Girl",
      GAMEID:
        "2663e14e5b455525252a25d9bd99e840",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Blossom-Of-Wealth.png",
      name: "Blossom Of Wealth",
      GAMEID:
        "ed6fbaeb7a104dd7ed96fa1683a48669",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Boom-Fiesta.png",
      name: "Boom Fiesta",
      GAMEID:
        "1ffb31ff605f1a7862a138f5cd712056",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Big-Three-Dragons.png",
      name: "Big Three Dragons",
      GAMEID:
        "600c338d3fca2da208f1bba2c9d29059",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mayagoldcrazy.png",
      name: "Mayagoldcrazy",
      GAMEID:
        "6c8009d165293759bb218b72ba3c380f",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lantern-Wealth.png",
      name: "Lantern Wealth",
      GAMEID:
        "f2f2eae301311f0320ef669b68935546",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Marvelous-Iv.png",
      name: "Marvelous Iv",
      GAMEID:
        "126cf2bfe8a8e606b362d23de02c0d5e",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Wonder-Elephant.png",
      name: "Wonder Elephant",
      GAMEID:
        "540da2ba4c849fc1c315f43ae74df220",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Kong.png",
      name: "Kong",
      GAMEID:
        "f6e9fd31cbc3be8cd3bd95486177377b",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Diamond.png",
      name: "Lucky Diamond",
      GAMEID:
        "6f6867ad1956a04b174c92629cab7f54",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Spindrift-2.png",
      name: "Spindrift 2",
      GAMEID:
        "05dc8c7a43305c3fcb43574c570d6378",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Jungle-Jungle.png",
      name: "Jungle Jungle",
      GAMEID:
        "6c5fe548bd6e09b683566298b29510ea",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragons-Gate.png",
      name: "Dragons Gate",
      GAMEID:
        "feaba603992f26633116fb54562e3693",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Spindrift.png",
      name: "Spindrift",
      GAMEID:
        "b624d1917ef5a740c151e4904a7cf0dd",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Double-Wilds.png",
      name: "Double Wilds",
      GAMEID:
        "7bd5233c83de0669336ee649e6c8d2b5",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Moneybags-Man.png",
      name: "Moneybags Man",
      GAMEID:
        "c4fdebb24ff26fffb3a65d018da8ae92",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Miner-Babe.png",
      name: "Miner Babe",
      GAMEID:
        "e705514fdd4f9bea5f82bbd0b2c0a353",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Super-Niubi-Deluxe.png",
      name: "Super Niubi Deluxe",
      GAMEID:
        "5d940d11c48b64ec1e6a3c8be5228250",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Funky-King-Kong.png",
      name: "Funky King Kong",
      GAMEID:
        "cdea2d0670bc40309b4a9b6f942a218a",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Golden-Disco.png",
      name: "Golden Disco",
      GAMEID:
        "dfb8a198ce0e821560cf543387a2acc2",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Treasure-Bowl.png",
      name: "Treasure Bowl",
      GAMEID:
        "0651af3e73c7600633522ffe15cc175b",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mjolnir.png",
      name: "Mjolnir",
      GAMEID:
        "e270f0674dff538b181499d18ab47845",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Pirate-Treasure.png",
      name: "Pirate Treasure",
      GAMEID:
        "bfb3241e64953f731e72bc833f2fa79a",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fortune-Treasure.png",
      name: "Fortune Treasure",
      GAMEID:
        "5a55a19d9cfbead5e64b8169e96bd27a",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Egypt-Treasure.png",
      name: "Egypt Treasure",
      GAMEID:
        "b7f39e861e2e02633cb5cb08958f1041",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Super-Niubi.png",
      name: "Super Niubi",
      GAMEID:
        "4042e5d0c777e1d3c3bd481dac0a867e",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragons-World.png",
      name: "Dragons World",
      GAMEID:
        "00b886803f3d067f7028872468e84745",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Go-Lai-Fu.png",
      name: "Go Lai Fu",
      GAMEID:
        "a3584394182e8abce362d90c2f048c75",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Birds-Party.png",
      name: "Birds Party",
      GAMEID:
        "7b497c4d19f87c86ea29910c12129edc",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Triple-King-Kong.png",
      name: "Triple King Kong",
      GAMEID:
        "a9f60e017f2765c74e1ec80473ac4ffa",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Orient-Animals.png",
      name: "Orient Animals",
      GAMEID:
        "bdb0459f7e116a20839a3b2a0063a2ff",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Seven.png",
      name: "Lucky Seven",
      GAMEID:
        "b560b7c42bd29f7d0cda06485a3c4af5",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Racing.png",
      name: "Lucky Racing",
      GAMEID:
        "8b51a987c5c536a894b592ae361d655d",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mining-Upstart.png",
      name: "Mining Upstart",
      GAMEID:
        "a26bdb5af2cf4964dfb241fbaec09252",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Rolling-In-Money.png",
      name: "Rolling In Money",
      GAMEID:
        "55bfa979698650a3580d169c1469f79c",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Daji.png",
      name: "Daji",
      GAMEID:
        "2254bbebab4925c0df6a98d9edcfeec4",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Kingsman.png",
      name: "Kingsman",
      GAMEID:
        "55e3b4d064b014a403be6ffba8c4343e",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Street-Fighter.png",
      name: "Street Fighter",
      GAMEID:
        "528e5d4fda0a34e233a28930783d2c63",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon.png",
      name: "Dragon",
      GAMEID:
        "735fcdbf9f5e6042132cc01e9860723f",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Warrior.png",
      name: "Dragon Warrior",
      GAMEID:
        "29135c91125ae1655f8c91eb29617705",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/One-Punch-Man.png",
      name: "One Punch Man",
      GAMEID:
        "5aa472006c8698cf6f59dd0548129cda",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Billionaire.png",
      name: "Billionaire",
      GAMEID:
        "16b1418fe87a6fa5628eec8cb40da056",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mr.-Bao.png",
      name: "Mr. Bao",
      GAMEID:
        "8c4681d49251042820069339dee4250c",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Panda-Panda.png",
      name: "Panda Panda",
      GAMEID:
        "6652927614dccaf87d8965c509e96f82",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Legendary-5.png",
      name: "Legendary 5",
      GAMEID:
        "04a3be36bbf1110345d53e07df9c9cc3",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Chef-Panda.png",
      name: "Chef Panda",
      GAMEID:
        "078a7876afc6553fd0c0c9d1cbe0b04a",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Fuwa.png",
      name: "Lucky Fuwa",
      GAMEID:
        "55946533d07080972b83c4aae1d4be2f",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Monkey-King.png",
      name: "Monkey King",
      GAMEID:
        "5ecca33d3cabee8cbab8897ce2843459",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Rooster-In-Love.png",
      name: "Rooster In Love",
      GAMEID:
        "2f24019dc8abbe05b984611462a1f01c",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Xi-Yang-Yang.png",
      name: "Xi Yang Yang",
      GAMEID:
        "f1496f1b49981a63e6064ac84517b5ae",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fortune-Horse.png",
      name: "Fortune Horse",
      GAMEID:
        "ca6e7b621b13077debbf1bf9d5a6c031",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Flirting-Scholar-Tang-Ii.png",
      name: "Flirting Scholar Tang Ii",
      GAMEID:
        "857d3426c220b4003cd0e4521c07e94b",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Open-Sesameii.png",
      name: "Open Sesameii",
      GAMEID:
        "558ca5b101d1be5bd7a08c6d01422c4f",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Winning-Mask-Ii.png",
      name: "Winning Mask Ii",
      GAMEID:
        "955ab46e30fcda3b2446169409848fa7",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Guan-Gong.png",
      name: "Guan Gong",
      GAMEID:
        "90bfd55dcf41709d27f1f38fd4a314a9",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Beauty-And-The-Kingdom.png",
      name: "Beauty And The Kingdom",
      GAMEID:
        "478d2e337f0d0a1b40e0e3521f89f1ba",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Phoenix.png",
      name: "Lucky Phoenix",
      GAMEID:
        "8244e0afc46b2b8a3446ec18ae0e129a",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Miner.png",
      name: "Lucky Miner",
      GAMEID:
        "8146db6ded1ef29540d262650817d090",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Olympian-Temple.png",
      name: "Olympian Temple",
      GAMEID:
        "ca11d9830495d2888d7e50770353ce32",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mahjong.png",
      name: "Mahjong",
      GAMEID:
        "e9d4b66c06a43e73ec8f1b2055f83c3a",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Banana-Saga.png",
      name: "Banana Saga",
      GAMEID:
        "77f407b50f00ec4569249b008a5adca0",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Open-Sesame.png",
      name: "Open Sesame",
      GAMEID:
        "d5cede7b6800bd9cd266cde8c4f73dc6",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Four-Treasures.png",
      name: "Four Treasures",
      GAMEID:
        "d53f82ab4fbb353480e012fd763bc339",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Napoleon.png",
      name: "Napoleon",
      GAMEID:
        "e4b973ece238c954fbcdf30fdfeae969",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/New-Year.png",
      name: "New Year",
      GAMEID:
        "319fb2a372755ff47f6adc4f36e67b0f",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Moonlight-Treasure.png",
      name: "Moonlight Treasure",
      GAMEID:
        "85e29fa6b578c6bf131ad4fdff750acb",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Lion.png",
      name: "Lucky Lion",
      GAMEID:
        "c1557ea0fad63c5e07b32d9f62ef1899",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Qilin.png",
      name: "Lucky Qilin",
      GAMEID:
        "f2298bcf0de0dccdd767d30b6e4f811a",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Formosa-Bear.png",
      name: "Formosa Bear",
      GAMEID:
        "e0afed167c1ef4c9a35c527a52419f0a",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/The-Llama-Adventure.png",
      name: "The Llama Adventure",
      GAMEID:
        "6800ef74e2b33c9a9155848f1328c8e5",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Wukong.png",
      name: "Wukong",
      GAMEID:
        "59acc6ad72fd6fb6cf30eb58cd9bedb8",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Winning-Mask.png",
      name: "Winning Mask",
      GAMEID:
        "4aebce625a1495532a25344f0e4ac584",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Flirting-Scholar-Tang.png",
      name: "Flirting Scholar Tang",
      GAMEID:
        "07df172c089e29e576aa41eeb0cbeb2b",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Dragons.png",
      name: "Lucky Dragons",
      GAMEID:
        "c32fff242e09a234f7350bb9aaa055cc",
      provider: "jdb",
    },
    {
      src: "https://drive.google.com/drive/folders/1Kspw4eE2ujFhE743nzkl_ZHSKodcYGtE",
      name: "Spirit Tide Legend",
      GAMEID:
        "638d38491dad4a6562713143b1fc6cc1",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fishing-Disco.png",
      name: "Fishing Disco",
      GAMEID:
        "e453b811fd1782fd2ade1f93ee0dee32",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Master.png",
      name: "Dragon Master",
      GAMEID:
        "f691d904ea681ce449263f7e9cc47c35",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fishing-Yilufa.png",
      name: "Fishing Yilufa",
      GAMEID:
        "877c97367d24925a11d342726eb0320f",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Shade-Dragons-Fishing.png",
      name: "Shade Dragons Fishing",
      GAMEID:
        "89e967a8336fb8caad2c1b6d735588fe",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Cai-Shen-Fishing.png",
      name: "Cai Shen Fishing",
      GAMEID:
        "6df463eabe5fcdaa033e1c89b9ffd162",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Fishing-Ii.png",
      name: "Dragon Fishing Ii",
      GAMEID:
        "6cef8d8ea517d86602db60fe9781b01b",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Fishing.png",
      name: "Dragon Fishing",
      GAMEID:
        "1145d7cd96518a5ba2f77cb14cb363c4",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Plinko.png",
      name: "Plinko",
      GAMEID:
        "cb54272cd536cf77eb6093bae2513095",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Hilo.png",
      name: "Hilo",
      GAMEID:
        "9ffbc085919e5e19f93a682fd3a737bb",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Goal.png",
      name: "Goal",
      GAMEID:
        "0160b30b64598290365f61211fb84a7b",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Firework-Burst.png",
      name: "Firework Burst",
      GAMEID:
        "19f082ffb4656934e80459a73ab73037",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mines.png",
      name: "Mines",
      GAMEID:
        "45a2a92108634508e5c47c690eb01c0b",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Galaxy-Burst.png",
      name: "Galaxy Burst",
      GAMEID:
        "37ca0b32e1908480e03db00cdc1bc2cf",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Jogo-Do-Bicho.png",
      name: "Jogo Do Bicho",
      GAMEID:
        "0e8432be6bc0cab304b41bc964aaf154",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Caishen-Party.png",
      name: "Caishen Party",
      GAMEID:
        "6437f1794f0753b268b2badbd69ef156",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Lucky-Color-Game.png",
      name: "Lucky Color Game",
      GAMEID:
        "5708005e9f2340dbd719567a94ba44b4",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/King-Of-Football.png",
      name: "King Of Football",
      GAMEID:
        "4088c7ed9db461f990d9514d6b9f7537",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Crazy-King-Kong.png",
      name: "Crazy King Kong",
      GAMEID:
        "c2c611f87d47faae8e4b285fe8145d41",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Super-Super-Fruit.png",
      name: "Super Super Fruit",
      GAMEID:
        "a9899c045de7873e620e0ef330f3fc73",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Huaguoshan-Legends.png",
      name: "Huaguoshan Legends",
      GAMEID:
        "6ff786580f7d9453728b9a8a3d1c3499",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Beer-Tycoon.png",
      name: "Beer Tycoon",
      GAMEID:
        "b133cf4f3c32b80344b381cc9f26442a",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Birds-And-Animals.png",
      name: "Birds And Animals",
      GAMEID:
        "db93ffd7164953bb1eb4c86b68542ed6",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Happy-New-Year.png",
      name: "Happy New Year",
      GAMEID:
        "d0b0d503d3d553643f665d5d2fdab138",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Classic-Mario.png",
      name: "Classic Mario",
      GAMEID:
        "627148e0dd36ff12df432fc920a0c59f",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Happy-Lottery.png",
      name: "Happy Lottery",
      GAMEID:
        "d6cd29e274d066e2e8f0cb171e7583a8",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Gold-Rooster-Lottery.png",
      name: "Gold Rooster Lottery",
      GAMEID:
        "2f3361619ef9520214c08fd2aecf33da",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Cai-Shen-Bingo.png",
      name: "Cai Shen Bingo",
      GAMEID:
        "f3629935719cf04d6b689933486177ce",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Tongits-Rush.png",
      name: "Tongits Rush",
      GAMEID:
        "3ecfba28c6c8f3ffce6c8134478a6bfa",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Tongits-Fight.png",
      name: "Tongits Fight",
      GAMEID:
        "6996a44ebff8fc97ce19cf791f4916cc",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Pusoy-Rush.png",
      name: "Pusoy Rush",
      GAMEID:
        "f03953d954b4ac3809efbedd5dfabec2",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Tiger-Joker-Bonus.png",
      name: "Dragon Tiger - Joker Bonus",
      GAMEID:
        "067d540d7ece7e7dfcfcadf11f25a71d",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Tongits.png",
      name: "Tongits",
      GAMEID:
        "47614f18718c2f911b89f00fd053b527",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Pusoy.png",
      name: "Pusoy",
      GAMEID:
        "f436610d0255b4e3646603a1e42793b7",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fighter-Fire.png",
      name: "Fighter Fire",
      GAMEID:
        "ff83699bef9b2e773857ed1a9eedc5fb",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dice.png",
      name: "Dice",
      GAMEID:
        "6aa921aebc8d7e170740cfc8e88426f6",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mole-Crash.png",
      name: "Mole Crash",
      GAMEID:
        "a170eb308c8fab8f2a5cdac5b427acbd",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mines2.png",
      name: "Mines2",
      GAMEID:
        "b1ad7a48e4d4839dbe53fcadf7eb5183",
      provider: "jdb",
    },
    {
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Pusoy.png",
      name: "Pusoy",
      GAMEID:
        "524ff2b54801f94ada51a1e2b37c593e",
      provider: "jdb",
    },
    {
      src: "",
      name: "Piggy Bank",
      GAMEID:
        "7d21ecdabd01130a22326115d3967ffa",
      provider: "jdb",
    },
  ]

  const spribe_games=[
    {
      src: "https://bindaaswin.com/jdb_images/22001_200x200_en.png",
      name: "Aviator",
      GAMEID:
        "a04d1f3eb8ccec8a4823bdf18e3f0e84",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22002_200x200_en.png",
      name: "Dice",
      GAMEID:
        "8a87aae7a3624d284306e9c6fe1b3e9c",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22003_200x200_en.png",
      name: "Goal",
      GAMEID:
        "c68a515f0b3b10eec96cf6d33299f4e2",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22004_200x200_en.png",
      name: "Plinko",
      GAMEID:
        "6ab7a4fe5161936012d6b06143918223",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22005_200x200_en.png",
      name: "Mines",
      GAMEID:
        "5c4a12fb0a9b296d9b0d5f9e1cd41d65",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22006_200x200_en.png",
      name: "Hilo",
      GAMEID:
        "a669c993b0e1f1b7da100fcf95516bdf",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22007_200x200_en.png",
      name: "Keno",
      GAMEID:
        "c311eb4bbba03b105d150504931f2479",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22008_200x200_en.png",
      name: "Mr Roulette",
      GAMEID:
        "9dc7ac6155c5a19c1cc204853e426367",
      provider: "jdb",
    },
    {
      src: "https://bindaaswin.com/jdb_images/22009_200x200_en.png",
      name: "Hotline",
      GAMEID:
        "b31720b3cd65d917a1a96ef61a72b672",
      provider: "jdb",
    },
  ]

  useEffect(() => {
    window.scrollTo(0,0);
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Initial check to set the correct sidebar state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    
  },[]);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <Banner />

               
                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Spribe</span>{" "}
                    <span className="all">See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={spribe_games} />
                  </div>
                </div>
                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};

export default RummyHome;
